const GalleryPage = () => <div>GalleryPage - Coming Soon</div>;
export default GalleryPage;
